/*
	--- アプリ連携（複数企画対応版） ---
*/

/**
 * 複数企画を管理するマネージャークラス
 */
class KikakuPageMultiManager {
  static modalOverlay = null;
  static confirmationPopup = null;
  static instances = new Map();
  static currentActiveInstance = null;

  /**
   * 静的初期化メソッド
   */
  static init() {
    console.log('KikakuPageMultiManager: 初期化開始');

    // 共有モーダル要素を作成
    this.createSharedModal();

    // 各企画コンテナを検索して個別インスタンスを作成
    const configElements = document.querySelectorAll('[data-wishlist-config]');
    console.log(`KikakuPageMultiManager: ${configElements.length}個の企画を検出`);

    configElements.forEach((configElement, index) => {
      const blockId = configElement.dataset.wishlistConfig;
      const container = document.querySelector(`[data-wishlist-content="${blockId}"]`);
      
      if (container) {
        console.log(`KikakuPageMultiManager: 企画${index + 1}を初期化 (ID: ${blockId})`);
        const instance = new KikakuPageManager(blockId, container, configElement);
        this.instances.set(blockId, instance);
      } else {
        console.warn(`KikakuPageMultiManager: Block ${blockId}内にmetaobject-wishlistが見つかりません`);
      }
    });

    // 共有モーダルのイベントリスナーを設定
    this.setupSharedEventListeners();

    console.log(`KikakuPageMultiManager: 初期化完了 (${this.instances.size}個の企画)`);
  }

  /**
   * 共有モーダル要素を作成
   */
  static createSharedModal() {
    // モーダルオーバーレイを作成
    if (!this.modalOverlay) {
      this.modalOverlay = document.createElement('div');
      this.modalOverlay.className = 'modal-overlay';
      document.body.appendChild(this.modalOverlay);
    }

    // 確認ポップアップを作成
    if (!this.confirmationPopup) {
      this.confirmationPopup = document.createElement('div');
      this.confirmationPopup.className = 'confirmation-popup';
      this.confirmationPopup.innerHTML = `
        <button class="confirmation-popup__close" aria-label="閉じる"></button>
        <div class="confirmation-popup__product">
          <div class="confirmation-popup__product-image"></div>
          <div class="confirmation-popup__product-title"></div>
          <div class="confirmation-popup__tag-lead"></div>
        </div>
        <div class="confirmation-popup__message"></div>
        <div class="confirmation-popup__buttons"></div>
      `;
      document.body.appendChild(this.confirmationPopup);

      // ×ボタンのイベントリスナーを設定
      const closeBtn = this.confirmationPopup.querySelector('.confirmation-popup__close');
      closeBtn.addEventListener('click', () => {
        this.hideConfirmationPopup();
      });
    }
  }

  /**
   * 共有イベントリスナーを設定
   */
  static setupSharedEventListeners() {
    // モーダル外クリックで閉じる
    this.modalOverlay.addEventListener('click', () => {
      if (this.confirmationPopup && this.confirmationPopup.classList.contains('active')) {
        this.hideConfirmationPopup();
      }
    });

    // ポップアップ内容をクリックした際に伝播を停止
    document.addEventListener('click', (event) => {
      if (event.target.closest('.confirmation-popup')) {
        event.stopPropagation();
      }
    });

    // キーボードイベントの処理
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        if (this.confirmationPopup && this.confirmationPopup.classList.contains('active')) {
          this.hideConfirmationPopup();
        }
      }
    });

    // レスポンシブ対応
    const handleResize = () => {
      const wishlistGrids = document.querySelectorAll('.wishlist-grid');
      wishlistGrids.forEach(grid => {
        const windowWidth = window.innerWidth;
        if (windowWidth <= 768) {
          grid.style.gridTemplateColumns = '1fr';
        } else {
          grid.style.gridTemplateColumns = 'repeat(2, 1fr)';
        }
      });
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('load', handleResize);
  }

  /**
   * 確認ポップアップを表示
   */
  static showConfirmationPopup(instance, itemElement, metaobjectId, currentPreference) {
    this.currentActiveInstance = instance;

    // 商品情報を取得
    const productTitle = itemElement.querySelector('.wishlist-item__title')?.textContent || '商品';
    const productImage = itemElement.querySelector('.wishlist-item__image img');
    const productTagline = itemElement.querySelector('.wishlist-item__tagline')?.textContent || '';

    // ポップアップ内の商品情報を更新
    const popupImage = this.confirmationPopup.querySelector('.confirmation-popup__product-image');
    const popupTitle = this.confirmationPopup.querySelector('.confirmation-popup__product-title');
    const popupTagLead = this.confirmationPopup.querySelector('.confirmation-popup__tag-lead');
    const popupMessage = this.confirmationPopup.querySelector('.confirmation-popup__message');
    const popupButtons = this.confirmationPopup.querySelector('.confirmation-popup__buttons');

    // 商品画像を設定
    if (productImage) {
      popupImage.innerHTML = `<img src="${productImage.src}" alt="${productImage.alt}" width="56" height="56">`;
    } else {
      popupImage.innerHTML = '';
    }

    // 商品名を設定
    popupTitle.textContent = productTitle;

    // 商品リードテキストを設定
    if(productTagline?.length > 0) {
      popupTagLead.textContent = productTagline;
      this.confirmationPopup.classList.add('confirmation-popup--has-tag-lead');
    } else {
      popupTagLead.textContent = '';
      this.confirmationPopup.classList.remove('confirmation-popup--has-tag-lead');
    }

    // メッセージとボタンを設定
    if (currentPreference && currentPreference !== 'null') {
      // 既に登録済みの場合
      const preferenceText = currentPreference === 'like' ? '好き' : '興味なし';
      popupMessage.innerHTML = `この商品は「${preferenceText}」に登録済みです<br/>「好みを変更する」を押下すると「保留中」となりますので、<br/>もう一度お好みを選択ください`;

      popupButtons.innerHTML = `
        <button class="confirmation-popup__button confirmation-popup__button--cancel" data-action="cancel">
          好みを変更する
        </button>
      `;
    } else {
      // 未登録の場合
      popupMessage.textContent = 'この商品の好みを選択してください';

      popupButtons.innerHTML = `
        <button class="confirmation-popup__button confirmation-popup__button--like" data-action="like">
          好き
        </button>
        <button class="confirmation-popup__button confirmation-popup__button--not-interested" data-action="not_interested">
          興味なし
        </button>
      `;
    }

    // ボタンにイベントリスナーを追加
    this.setupPopupButtonListeners(instance, itemElement, metaobjectId, currentPreference);

    // オーバーレイとポップアップを表示
    this.modalOverlay.classList.add('active');
    this.confirmationPopup.classList.add('active');
  }

  /**
   * ポップアップボタンのイベントリスナーを設定
   */
  static setupPopupButtonListeners(instance, itemElement, metaobjectId, currentPreference) {
    const buttons = this.confirmationPopup.querySelectorAll('.confirmation-popup__button');

    buttons.forEach(button => {
      // 既存のイベントリスナーを削除
      button.replaceWith(button.cloneNode(true));
    });

    // 新しいボタン要素を取得してイベントリスナーを追加
    const newButtons = this.confirmationPopup.querySelectorAll('.confirmation-popup__button');
    newButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const action = e.target.getAttribute('data-action');
        if (action === 'like') {
          instance.handleEventResponse(metaobjectId, 'like', 'register');
        } else if (action === 'not_interested') {
          instance.handleEventResponse(metaobjectId, 'not_interested', 'register');
        } else if (action === 'cancel') {
          instance.handleEventResponse(metaobjectId, currentPreference, 'cancel');
        }
      });
    });
  }

  /**
   * ポップアップボタンを無効化
   */
  static disablePopupButtons() {
    const buttons = this.confirmationPopup.querySelectorAll('.confirmation-popup__button');
    buttons.forEach(button => {
      button.disabled = true;
      button.dataset.originalText = button.textContent;
      button.textContent = '処理中...';
    });
  }

  /**
   * ポップアップボタンを有効化
   */
  static enablePopupButtons() {
    const buttons = this.confirmationPopup.querySelectorAll('.confirmation-popup__button');
    buttons.forEach(button => {
      button.disabled = false;
      if (button.dataset.originalText) {
        button.textContent = button.dataset.originalText;
        delete button.dataset.originalText;
      }
    });
  }

  /**
   * 確認ポップアップを非表示
   */
  static hideConfirmationPopup() {
    this.confirmationPopup.classList.remove('active');
    this.modalOverlay.classList.remove('active');
    this.currentActiveInstance = null;
  }
}

/**
 * 個別企画を管理するクラス
 */
class KikakuPageManager {
  constructor(blockId, container, configElement) {
    this.blockId = blockId;
    this.wishlistItems = [];
    this.currentItemElement = null;
    this.currentMetaobjectId = null;
    this.currentPreference = null;
    this.container = container;
    this.customerId = null;
    this.objectType = null;
    this.defaultUrl = null;
    this.dailyPostCountLimit = null;
    this.linkedKikakuList = null;

    console.log(`KikakuPageManager[${blockId}]: インスタンス作成`);
    this.init(configElement);
  }

  /**
   * 初期化処理
   */
  init(configElement) {
    // 設定を取得
    this.loadConfig(configElement);

    // DOM要素を取得
    this.wishlistItems = this.container.querySelectorAll('.wishlist-item');
    console.log(`KikakuPageManager[${this.blockId}]: ${this.wishlistItems.length}個のアイテムを検出`);

    // イベントリスナーを設定
    this.setupEventListeners();
  }

  /**
   * 設定を取得
   */
  loadConfig(configElement) {
    if (configElement) {
      try {
        const config = JSON.parse(configElement.textContent);
        this.customerId = config.customerId;
        this.objectType = config.objectType;
        this.defaultUrl = config.defaultUrl;
        this.dailyPostCountLimit = config.dailyPostCountLimit;
        this.linkedKikakuList = config.linkedKikakuList || [];

        console.log(`KikakuPageManager[${this.blockId}]: 設定を読み込み`, {
          objectType: this.objectType,
          dailyPostCountLimit: this.dailyPostCountLimit,
          linkedKikakuCount: this.linkedKikakuList.length
        });
      } catch (error) {
        console.error(`KikakuPageManager[${this.blockId}]: 設定の読み込みに失敗`, error);
      }
    }
  }

  /**
   * イベントリスナーを設定
   */
  setupEventListeners() {
    // 顧客がログインしている場合、各アイテムにクリックイベントを追加
		if(this.customerId) {
			this.wishlistItems.forEach((item, index) => {
				// アイテム全体クリックで確認ポップアップを表示
				item.addEventListener('click', () => {
					const actionsContainer = item.querySelector('.wishlist-item__actions');
					const metaobjectId = actionsContainer?.querySelector('[data-posted-metaobject-id]')?.getAttribute('data-posted-metaobject-id');
					const currentPreference = actionsContainer?.getAttribute('data-current-preference');

					if (metaobjectId) {
						this.currentItemElement = item;
						this.currentMetaobjectId = metaobjectId;
						this.currentPreference = currentPreference;
						KikakuPageMultiManager.showConfirmationPopup(this, item, metaobjectId, currentPreference);
					}
				});
			});
		}
  }

  /**
   * 今日の日付を取得（YYYY-MM-DD形式）
   * @returns {string} 今日の日付
   */
  getTodayString() {
    const now = new Date();
    return now.getFullYear() + '-' +
           String(now.getMonth() + 1).padStart(2, '0') + '-' +
           String(now.getDate()).padStart(2, '0');
  }

  /**
   * 連動企画の制限情報用LocalStorageキーを生成
   * @returns {string} LocalStorageキー
   */
  getLinkedKikakuLimitKey() {
    return `linked_kikaku_limits_${this.customerId}`;
  }

  /**
   * 連動企画の制限情報を取得（配列形式）
   * @returns {Array} 制限情報の配列
   */
  getLinkedKikakuLimitData() {
    const key = this.getLinkedKikakuLimitKey();
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : [];
  }

  /**
   * 連動企画の制限情報を保存（配列形式）
   * @param {Array} limitDataArray - 制限情報の配列
   */
  saveLinkedKikakuLimitData(limitDataArray) {
    const key = this.getLinkedKikakuLimitKey();
    localStorage.setItem(key, JSON.stringify(limitDataArray));
  }

  /**
   * 古い日付の制限定義を削除
   */
  cleanupOldLimitData() {
    const today = this.getTodayString();
    const dataArray = this.getLinkedKikakuLimitData();

    if (dataArray && dataArray.length > 0) {
      // 今日の日付のデータのみ保持
      const todayData = dataArray.filter(data => data.日付 === today);
      if (todayData.length !== dataArray.length) {
        this.saveLinkedKikakuLimitData(todayData);
      }
    }
  }

  /**
   * 現在の企画が連動企画に含まれているかチェック
   * @param {Array<string>} linkedKikakuList - 連動企画リスト
   * @returns {boolean} 含まれているかどうか
   */
  isCurrentKikakuInLinkedList(linkedKikakuList) {
    if (!Array.isArray(linkedKikakuList)) {
      return false;
    }
    return linkedKikakuList.includes(this.objectType);
  }

  /**
   * 連動企画の制限情報を取得または作成
   * @returns {Object|null} 制限情報
   */
  getOrCreateLinkedKikakuLimit() {
    const today = this.getTodayString();
    let dataArray = this.getLinkedKikakuLimitData();

    // 古いデータを削除
    this.cleanupOldLimitData();
    dataArray = this.getLinkedKikakuLimitData();

    // Liquidから取得したlinkedKikakuListを使用
    let linkedKikakuList = this.linkedKikakuList || [];
    if (!linkedKikakuList.includes(this.objectType)) {
      linkedKikakuList = [this.objectType, ...linkedKikakuList];
    }

    // 連動企画リストをソートして一意なグループIDを作成
    const groupId = linkedKikakuList.slice().sort().join(',');

    // 既存のグループを検索
    let limitData = dataArray.find(data => {
      const existingGroupId = data.連動する企画.slice().sort().join(',');
      return existingGroupId === groupId && data.日付 === today;
    });

    if (limitData) {
      return limitData;
    }

    // 新しい制限情報を作成
    const dailyLimit = this.dailyPostCountLimit || 0;
    if (dailyLimit > 0) {
      limitData = {
        "日付": today,
        "連動する企画": linkedKikakuList,
        "1日あたりの制限数": dailyLimit,
        "本日の閲覧数": 0,
        "制限適用": true
      };

      dataArray.push(limitData);
      this.saveLinkedKikakuLimitData(dataArray);
      return limitData;
    }

    // 制限が設定されていない場合はnullを返す
    return null;
  }

  /**
   * 投稿制限チェック（連動企画対応）
   * @param {string} metaobjectId - チェック対象のmetaobject-id
   * @returns {boolean} 投稿可能かどうか
   */
  canPost(metaobjectId) {
    const limitData = this.getOrCreateLinkedKikakuLimit();

    // 制限が設定されていない場合は常に投稿可能
    if (!limitData || !limitData.制限適用 || limitData["1日あたりの制限数"] <= 0) {
      return true;
    }

    // 現在の企画が連動企画に含まれていない場合は投稿可能
    if (!this.isCurrentKikakuInLinkedList(limitData.連動する企画)) {
      return true;
    }

    const metaobjectIdString = metaobjectId.toString();

    // 既に投稿済みのアイテムの場合は投稿可能（好み変更）
    if (this.isPostedTodayInLinkedKikaku(metaobjectIdString, limitData)) {
      return true;
    }

    // 新規投稿の場合は制限チェック
    return limitData["本日の閲覧数"] < limitData["1日あたりの制限数"];
  }

  /**
   * 連動企画でアイテムが今日投稿済みかチェック
   * @param {string} metaobjectId - チェック対象のmetaobject-id
   * @param {Object|null} limitData - 制限情報
   * @returns {boolean} 今日投稿済みかどうか
   */
  isPostedTodayInLinkedKikaku(metaobjectId, limitData) {
    // limitDataがnullまたは連動する企画が存在しない場合はfalseを返す
    if (!limitData || !limitData.連動する企画) {
      return false;
    }

    // 個別企画のLocalStorageも確認する必要がある場合は、
    // 連動企画すべてのLocalStorageをチェック
    for (const kikakuType of limitData.連動する企画) {
      const key = `kikaku_daily_post_items_${this.customerId}_${limitData.日付}_${kikakuType}`;
      const items = localStorage.getItem(key);
      if (items) {
        const itemList = JSON.parse(items);
        if (itemList.includes(metaobjectId)) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * 連動企画で投稿したアイテムIDを追加
   * @param {string} metaobjectId - 投稿したアイテムのmetaobject-id
   */
  addTodayPostedItemToLinkedKikaku(metaobjectId) {
    const limitData = this.getOrCreateLinkedKikakuLimit();

    if (!limitData || !this.isCurrentKikakuInLinkedList(limitData.連動する企画)) {
      return;
    }

    const metaobjectIdString = metaobjectId.toString();

    // 既に投稿済みでない場合のみ追加
    if (!this.isPostedTodayInLinkedKikaku(metaobjectIdString, limitData)) {
      // 個別企画のLocalStorageに記録
      const key = `kikaku_daily_post_items_${this.customerId}_${limitData.日付}_${this.objectType}`;
      const currentItems = JSON.parse(localStorage.getItem(key) || '[]');
      currentItems.push(metaobjectIdString);
      localStorage.setItem(key, JSON.stringify(currentItems));

      // 連動企画の閲覧数を増加して配列全体を保存
      limitData["本日の閲覧数"] += 1;

      // 配列全体を取得して更新
      const dataArray = this.getLinkedKikakuLimitData();
      const groupId = limitData.連動する企画.slice().sort().join(',');
      const index = dataArray.findIndex(data => {
        const existingGroupId = data.連動する企画.slice().sort().join(',');
        return existingGroupId === groupId && data.日付 === limitData.日付;
      });

      if (index !== -1) {
        dataArray[index] = limitData;
        this.saveLinkedKikakuLimitData(dataArray);
      }
    }
  }

  /**
   * 制限到達時のメッセージを取得（連動企画対応）
   * @returns {string} 制限到達メッセージ
   */
  getLimitReachedMessage() {
    const limitData = this.getOrCreateLinkedKikakuLimit();

    if (!limitData) {
      return '投稿制限の情報を取得できませんでした。';
    }

    return `連動企画全体で1日の投稿上限（${limitData["1日あたりの制限数"]}アイテム）に達しています。現在${limitData["本日の閲覧数"]}アイテム投稿済みです。明日以降にお試しください。`;
  }

  /**
   * 企画回答処理（好き/興味なし）
   * @param {string} metaobjectId - 投稿アイテムID
   * @param {string} action - 好み（like, not_interested）
   * @param {string} is_cancel - 操作（register, cancel）
   */
  async handleEventResponse(metaobjectId, action, is_cancel) {
    console.log(`KikakuPageManager[${this.blockId}]: handleEventResponse`, { metaobjectId, action, is_cancel });

    if (!this.customerId) {
      alert('回答機能を使用するにはログインが必要です。');
      return;
    }

    // 新規投稿時の制限チェック
    if (is_cancel === 'register') {
      if (!this.canPost(metaobjectId)) {
        alert(this.getLimitReachedMessage());
        return;
      }
    }

    // ポップアップボタンを無効化
    KikakuPageMultiManager.disablePopupButtons();

    const button = this.container.querySelector(`[data-posted-metaobject-id="${metaobjectId}"]`);
    if (!button) {
      KikakuPageMultiManager.enablePopupButtons();
      return;
    }

    try {
      const response = await fetch(this.defaultUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          'customer_id': this.customerId,
          'metaobject_type': this.objectType,
          'target_type': 'metaobject',
          'value': metaobjectId,
          'action': action,
          'is_cancel': is_cancel
        })
      });

      const result = await response.json();

      if (response.ok) {
        // 成功時の処理：アイテムIDを記録（新規投稿かつ未投稿の場合のみ）
        if (is_cancel === 'register') {
          const limitData = this.getOrCreateLinkedKikakuLimit();
          if (limitData && !this.isPostedTodayInLinkedKikaku(metaobjectId, limitData)) {
            this.addTodayPostedItemToLinkedKikaku(metaobjectId);
          }
        }

        // ページリロード
        window.location.reload();

      } else {
        // エラー時の処理
        KikakuPageMultiManager.enablePopupButtons();
        alert('エラーが発生しました: ' + (result.error || '不明なエラー'));
      }
    } catch (error) {
      KikakuPageMultiManager.enablePopupButtons();
      alert('エラーが発生しました。時間をおいて再度お試しください。');
      console.error(`KikakuPageManager[${this.blockId}]: Error`, error);
    }
  }
}

/*
	--- タブ切り替え機能 ---
*/
class TabManager {
  constructor() {
    this.tabs = document.querySelectorAll('.c-kikaku-page .TabList__Item');
    this.blocks = document.querySelectorAll('.c-kikaku-page .TabPanel');

    if (this.tabs.length > 0) {
      this.init();
    }
  }

  init() {
    console.log('TabManager: 初期化開始', {
      tabCount: this.tabs.length,
      blockCount: this.blocks.length
    });

    // タブクリックイベントの設定
    this.tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = tab.getAttribute('aria-controls');
        this.switchTab(targetId);

        // URLパラメータを更新（履歴に追加）
        this.updateUrlParameter(targetId);
      });
    });

    // URLパラメータからタブを選択
    this.selectTabFromUrl();
  }

  /**
   * タブを切り替える
   * @param {string} targetBlockId - 表示するブロックのID
   */
  switchTab(targetBlockId) {
    console.log("targetBlockId",targetBlockId);
    // すべてのタブとブロックを非アクティブにする
    this.tabs.forEach(tab => {
      tab.classList.remove('is-active');
      tab.setAttribute('aria-selected', 'false');
    });

    this.blocks.forEach(block => {
      block.style.display = 'none';
      block.setAttribute('aria-hidden', 'true');
    });

    // 指定されたタブとブロックをアクティブにする
    const activeTab = document.querySelector(`[aria-controls="${targetBlockId}"]`);
    const activeBlock = document.querySelector(`#${targetBlockId}`);

    if (activeTab && activeBlock) {
      activeTab.classList.add('is-active');
      activeTab.setAttribute('aria-selected', 'true');

      activeBlock.style.display = 'block';
      activeBlock.setAttribute('aria-hidden', 'false');

      console.log(`TabManager: タブ切り替え - ${targetBlockId}`);
    }
  }

  /**
   * URLパラメータからタブを選択
   */
  selectTabFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get('tab');

    if (tabParam) {
      const targetTab = document.querySelector(`.TabList__Item[data-anker-id="${tabParam}"]`);

      if (targetTab) {
        const targetId = targetTab.getAttribute('aria-controls');
        this.switchTab(targetId);
      }
    } else {
      this.showFirstTab();
    }
  }

  /**
   * 最初のタブを表示
   */
  showFirstTab() {
    if (this.tabs.length > 0) {
      const firstTab = this.tabs[0];
      const targetId = firstTab.getAttribute('aria-controls');
      this.switchTab(targetId);
    } else if (this.blocks.length > 0) {
      // タブがない場合（単一ブロックの場合）は最初のブロックを表示
      this.blocks[0].style.display = 'block';
      this.blocks[0].setAttribute('aria-hidden', 'false');
    }
  }

  /**
   * URLパラメータを更新
   * @param {string} targetBlockId - ブロックID
   */
  updateUrlParameter(targetBlockId) {
    const targetBlock = document.querySelector(`#${targetBlockId}`);
    const ankerId = targetBlock?.getAttribute('data-anker-id');

    if (ankerId) {
      const url = new URL(window.location);
      url.searchParams.set('tab', ankerId);

      // URLを更新（ページリロードなし）
      window.history.pushState({ tab: ankerId }, '', url);
    }
  }
}

/*
	--- 投稿モーダル表示制御 ---
*/
// DOM読み込み完了後に実行
document.addEventListener('DOMContentLoaded', function() {
  // タブマネージャーを初期化
  const tabManager = new TabManager();

  // 企画マネージャーを初期化
  KikakuPageMultiManager.init();
});